module.exports = __webpack_public_path__ + "img/y-71.58f3859c.png";